<template>
  <div id="app uk-offcanvas-content">
    <component :is="layout">
    <router-view />
    </component>
  </div>
</template>

<script>
const default_layout = "default";
export default {
  computed: {
    layout() {
      let layoutname = (this.$route.meta.layout || default_layout) + "-layout";
      console.log("loading with layout: " + layoutname);
      return layoutname;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

footer span.uk-icon {
    color: #fff;
    float: left;
    margin-right: 10px;
    background-color: #abd037;
    border-radius: 10px;
    padding: 10px;
}

footer span.fb-title {
    color: #0099ff !important;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 1.7em;
    display: inline-block;
    float: left;
    margin-top: 5px;
    margin-bottom: 3px;
    font-family: "Open Sans", serif;
}

footer span.fb-slogan {
    color: #ff9933 !important;
    font-weight: bold;
    font-size: 0.8em;
    margin-bottom: 3px;
    float: left;
}

footer i.fb-icon {
    color: #abd037;
    float: left;
    margin-right: 10px;
}


</style>
